module.exports = "/_next/static/images/0666893d31ebe02b70f7a248cf15c8ea-rewards-hosting@3x.png";